// extracted by mini-css-extract-plugin
export default {"contentWrap":"CompanyInfo_contentWrap__lvQgb","themeColor":"CompanyInfo_themeColor__kLrFL","inlineText":"CompanyInfo_inlineText__-huIq"};